<template>
    <div class="page zntjMd">
         <div class="page-header">
            <div class="sort-condition">
                    <div class="stItem stImType" v-if="NODE_ENV !='erp' && NODE_ENV !='erp-prod'"><span class="ss">执行人</span>
                        <div class="stType">
                            <template v-if="staffInfo.accountType.code === 0">
                                    <span v-if="employeeName">{{employeeName}}<i class="el-tag__close tficon-shanchubiaoqianmoren tficonfont" @click="deleteName"></i></span>
                                    <template v-else>
                                        <div @click="addStaff">
                                            <i class="addIcon"><img src="@/assets/icon/add_icon.png" alt=""></i>添加
                                        </div>
                                    </template>
                            </template>
                             <span v-else>{{staffInfo.nickName}}</span>
                        </div>
                    </div>
                    <div class="stItem stImTime"><span class="ss">创建时间</span>
                        <div class="stType">
                                <span :class="timeType == 4?'active2':''" @click="sortCleaningTime(4)">全部</span>
                                <span :class="timeType == 1?'active2':''" @click="sortCleaningTime(1)">今天</span>
                                <span :class="timeType == 2?'active2':''" @click="sortCleaningTime(2)">昨天</span>
                                <span :class="timeType == 3?'active2':''" @click="sortCleaningTime(3)">近7天</span>
                                <el-date-picker v-model="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" unlink-panels range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"
                                  type="daterange" size="small" class="mr-16" @change="sortCleaningTime(5)"></el-date-picker>
                        </div>
                    </div>
            </div>
        </div>
        <div class="intelBox" v-loading="waiting">
                <div class="number-infor">
                        <div class="titile">号码清洗统计</div>
                        <div class="numItem">
                             <div class="total">
                                    <span class="ttNum">{{numberTotal}}</span>
                                    <span class="ttTxt">号码总数</span>
                             </div>
                             <div class="total-sort">
                                    <div class="item" v-for="(item,index) in numberStatusCircle" :key="index">
                                        <el-progress type="circle" :width="60" :stroke-width="8" :percentage="item.percentage" :color="item.color" :class="'pgs'+index"></el-progress>
                                            <p>
                                                <span class="ttNum">{{item.num}}</span>
                                                <span class="ttTxt">{{item.name}}</span>
                                            </p>
                                    </div>
                             </div>
                        </div>
                        <div class="smallTit">号码清洗记录&nbsp;&nbsp;  共 <span style="color:#5088FF;">{{this.list.total}}</span> 个任务</div>
                        <el-table
                            :data="list.tableData"
                            style="width: 100%"
                            innerpage
                            class="cleaningTable"
                            >
                            
                            <el-table-column
                                prop="name"
                                label="任务名称"
                                min-width="145"
                                >
                                <template slot-scope="scope">
                                    <el-tooltip effect="light" :content="scope.row.name" placement="top">
                                     <span class="textOverflow">{{scope.row.name}}</span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="nickName"
                                label="执行人"
                                min-width="130"
                                >
                                <template slot-scope="scope">
                                    <el-tooltip effect="light" :content="scope.row.nickName" placement="top">
                                     <span class="textOverflow">{{scope.row.nickName}}</span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="创建时间"
                                min-width="130"
                                >
                            </el-table-column>
                            <el-table-column
                                prop="checkState"
                                label="检测状态">
                                <template slot-scope="scope">
                                        <span :class="['stateCss',scope.row.checkState == 1?'checkingCss':'checkingCompleteCss']">{{scope.row.checkState == 1?'检测中':'检测完成'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="count"
                                label="号码数量"
                                >
                                <template slot-scope="scope">
                                    <span>{{scope.row.count || '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="highNum"
                                label="优质号码"
                                >
                                <template slot-scope="scope">
                                    <span>{{scope.row.highNum || '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="silenceNum"
                                label="沉默号"
                                >
                                 <template slot-scope="scope">
                                    <span>{{scope.row.silenceNum || '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="emptyNum"
                                label="空号"
                                >
                                <template slot-scope="scope">
                                    <span>{{scope.row.emptyNum || '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="riskNum"
                                label="风险号"
                                >
                                <template slot-scope="scope">
                                    <span>{{scope.row.riskNum || '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="type"
                                label="操作"
                                width="58"
                                >
                                <template slot-scope="scope">
                                        <el-button type="text" :disabled="scope.row.checkState == 1" @click="goDetail(scope.row.id,scope.row.name)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagination v-if="list.tableData.length" :pageNum="list.pageNum" :pageSize="list.pageSize" :total="list.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" :key="list.pageNum" />
                </div>
        </div>
        <robot />
        <right-float ref="rightFloat" :globalRfType="true"></right-float>
        <CleaingDetail ref="CleaingDetail"></CleaingDetail>
        <ActionStaffDialog ref="ActionStaffDialog" @getBindAccountObj="getBindAccountObj"></ActionStaffDialog>
    </div>
</template>
<script>
import Robot from '../components/robot'
import pagination from '@/components/pagination/'
import CleaingDetail from '@/components/cleaningDetail'
import ActionStaffDialog from '@/components/actionStaffDialog'
import RightFloat from '@/components/rightFloatBtn'
import { cleaningNumberList ,cleaningNumberNum} from '../api/cleaningApi'
import moment from 'moment'
import {mapState} from 'vuex'
export default {
    name: 'numberCleaningList',
    components:{
      pagination,
      CleaingDetail,
      ActionStaffDialog,
      Robot,
      RightFloat
    },
    data(){
        return{
              waiting:false,
              timeType:4,//时间类型
              list: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0,
                    tableData: []
                },
              loginName:'',//登录名
              employeeName:'',//执行人员Name
              accountIds:[],//执行人员id
              accountId:'',//执行人员id
              date: [],
              startTime:'',//创建开始时间
              endTime:'',//创建结束时间
              pickerOptions: {
                disabledDate(time) {
                return time.getTime() > Date.now()
                },
            
                shortcuts: [{
                text: '今天',
                onClick (picker) {
                    const start = new Date()
                    const end = new Date()
                    picker.$emit('pick', [start, end])
                }
                }, {
                text: '昨天',
                onClick (picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
                    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
                    picker.$emit('pick', [start, end])
                }
                }, {
                text: '过去7天',
                onClick (picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    picker.$emit('pick', [start, end])
                }
                }]
            },
            numberTotal:0,//清洗号码总数
            numberStatusCircle:[{
                name:'优质号码',enName:'highNum',num:0,percentage:0,color:'#30BF78'
            },{
                name:'沉默号',enName:'silenceNum',num:0,percentage:0,color:'#5088FF'
            },{
                name:'空号',enName:'emptyNum',num:0,percentage:0,color:'#BBBECA'
            },{
                name:'风险号',enName:'riskNum',num:0,percentage:0,color:'#FF0000'
            }],
            NODE_ENV:""
        }
    },
    computed:{
        ...mapState({
            staffInfo:state => state.user.staffInfo,
            erpUserName:state => state.user.erpUserName
        })
    },
    mounted(){
     this.getListSortData()
     this.NODE_ENV = process.env.NODE_ENV
    },
    methods:{
        getListSortData(){
            this.list.pageNum = 1
            this.list.pageSize = 10
            this.getcleaningNumberList()
            this.getCleaningNumberNum()
        },
        getBindAccountObj(val){
            // let arr = []
            // arr.push(val.bindAccountId)
            // this.accountIds = arr
            this.accountId = val.bindAccountId
            this.employeeName = val.employeeName
            this.loginName = val.loginName
        },
      deleteName(){
          this.loginName = ''
          this.employeeName = ''
          this.accountId = ''
        //   this.accountIds = []
        this.getListSortData()
      },
      async getcleaningNumberList(){
          let params = {
              pageNum:this.list.pageNum,
              pageSize:this.list.pageSize,
            //   accountIds:this.accountIds + ''
              accountId:this.accountId
          }
          if(this.timeType == 5){
              
            //   params.startTime = this.date?this.date[0]:undefined
            //   params.endTime = this.date?this.date[1]:undefined
              params.startTime = this.date?this.date[0]:''
              params.endTime = this.date?this.date[1]:''
              this.timeType = this.date ? 5 : 4
              this.startTime = this.date?this.date[0]:''
              this.endTime = this.date?this.date[1]:''
          }else{
              params.startTime = this.startTime
              params.endTime = this.endTime
          }
          try{
                this.waiting = true
                const res = await cleaningNumberList(params)
                if(res.code == 200){
                        this.list.tableData = res.data.records
                        this.list.total = res.data.total
                }
                this.waiting = false
          }catch(err){
               this.waiting = false
          }
        },
      async getCleaningNumberNum(){
            let params = {
              pageNum:this.list.pageNum,
              pageSize:this.list.pageSize,
            //   accountIds:this.accountIds + ''
             accountId:this.accountId

          }
          if(this.timeType == 4 || this.timeType == 5){
             params.startTime = this.date?this.date[0]:undefined
              params.endTime = this.date?this.date[1]:undefined
          }else{
              params.startTime = this.startTime
              params.endTime = this.endTime
          }
           const res = await cleaningNumberNum(params)
           if(res.code == 200){
               if(res.data){
                    this.numberTotal = res.data.count
                    this.numberStatusCircle.forEach(v=>{
                        for(const key in res.data){
                            if(v.enName == key){
                                v.num = res.data[key]
                                v.percentage =res.data[key] == 0 ? 0 : Number(parseFloat((res.data[key] / res.data.count)*100).toFixed(1))
                            }
                        }
                    })
               }else{
                   this.numberTotal = 0
                   this.numberStatusCircle.forEach(v=>{
                        v.num = 0
                        v.percentage = 0
                    })
               }
           }
      },
        sortCleaningTime(val){
           this.date = val == 5?this.date:[]
           this.list.pageNum = 1
           this.list.pageSize = 10
           this.timeType = val
           let end = new Date()
           let start = new Date()
        if(val == 1){
                start = moment(start).format("YYYY-MM-DD")
                end = moment(end).format("YYYY-MM-DD")
        }else if(val == 2){
               start = moment(start.getTime() - 3600 * 1000 * 24 * 1).format("YYYY-MM-DD")
               end = moment(end.getTime() - 3600 * 1000 * 24 * 1).format("YYYY-MM-DD")
        }else if(val == 3){
               start = moment(start.getTime() - 3600 * 1000 * 24 * 7).format("YYYY-MM-DD")
               end = moment(end).format("YYYY-MM-DD")
        }else if(val == 4){
            start = ''
            end = ''
        }
        this.startTime = start
        this.endTime = end
        this.getListSortData()
        },
        addStaff(){
            this.$refs.ActionStaffDialog.iniFun()
        },
        handleSizeChange(val){
         this.list.pageSize = val
         this.list.pageNum = 1
         this.getcleaningNumberList()
        },
        handleCurrentChange (val) {
        this.list.pageNum = val
        this.getcleaningNumberList()
        },
        goDetail(id,name){
          this.$refs.CleaingDetail.iniFun(id,name)
        }
    }
}
</script>
<style scoped lang='scss'>
.page-header {
    padding: 0 24px;
    align-items: center;
    
    background: #FFFFFF;
    box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
    border-radius: 4px;
    margin-bottom: 16px;
    .page-title {
        // color: #409eff;
        font-size: 16px;
        span{
        font-size: 13px;
        }
    }
    &-action {
        margin-left: auto;
        display: flex;
        align-items: center;
        i {
        cursor: pointer;
        font-size: 18px;
        margin-right: 12px;
        color: #409eff;
        }
    }
    }
.page-header{
    .div-tabs{
            position: relative;
            border-bottom:1px solid #EEEEEE;
            padding-top: 17px;
            padding-bottom: 10px;
            margin-bottom: 20px;
            .tabName{
                height: 48px;
                font-weight: bold;
                color: #333333;
                font-size: 15px;
                padding: 0 16px;
                box-sizing: border-box;
                position: relative;
                &::after{
                    content: '';
                    display: block;
                    width: 62px;
                    height: 2px;
                    position: absolute;
                    background: #5088FF;
                    bottom: -12px;
                }
            }
    }
    .page-header-action{
            position: absolute;
            right: 0;
            bottom: 8px;
    }
    .sort-condition{
            padding-top: 20px;
            padding-bottom: 20px;
            .stItem{
                display: flex;
                font-weight: 400;
                color: #333333;
                font-size: 14px;
                &.stImType{
                        margin-bottom: 12px;
                        .stType{
                            line-height: 36px;
                            cursor: pointer;
                        }
                }
                &.stImTime{
                        .stType{
                            span{
                                    position: relative;
                                    background: rgba(229, 230, 232, 0.3);
                                    border-radius: 2px;
                                    margin-right: 8px;
                                    padding: 10px 8px;
                                    box-sizing: border-box;
                                    cursor: pointer;
                                    font-weight: 400;
                                    color: #666666;
                                    font-size: 14px;
                                    &.active2{
                                        background: rgba(80, 136, 255, 0.1);
                                        color: #5088FF;
                                    }
                            }
                          .el-range-editor--small.el-input__inner{
                              height: 36px;
                          }  
                        }
                }
                .ss{
                    min-width: 56px;
                    text-align: right;
                    margin-right: 8px;
                    line-height: 36px;
                }
            }
            
            .addIcon{
                width: 16px;
                height: 16px;
                background: #5088FF;
                border-radius: 50%;
                position: relative;
                display: inline-block;
                vertical-align: text-bottom;
                margin-right: 2px;
                img{
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    top: 0;
                    margin: auto;
                    max-width: 100%;
                }
            }
    }
}
.page.zntjMd{
   position: relative;
}
.intelBox{
    padding: 16px 24px;
    box-sizing: border-box;
    background: #FFFFFF;
   box-shadow: 0px 1px 5px 0px rgba(38,38,38,0.1);
   margin-bottom: 24px;
   .number-infor{
       .titile{
           font-weight: bold;
            color: #333333;
            line-height: 20px;
            font-size: 14px;
       }
       .numItem{
           border-bottom: 1px solid #E8E8F0;
           padding: 24px 46px;
           box-sizing: border-box;
           display: flex;
           margin-bottom: 24px;
           .total{
               min-width: 180px;
               border-right: 1px solid #E8E8F0;
               span{
                   display: block;
               }
               .ttNum{
                   font-size: 58px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #5088FF;
                    line-height: 54px;
                    margin-bottom: 4px;
               }
               .ttTxt{
                    font-weight: 400;
                    color: #666666;
                    line-height: 20px;
                    font-size: 14px;
               }
           }
           .total-sort{
               display: flex;
               width: 100%;
               padding: 0 88px;
               box-sizing: border-box;
               justify-content: center;
               align-items: center;
               .item{
                   flex: 1;
                   min-width: 191px;
                   .el-progress{
                       float: left;
                       margin-right: 8px;
                   }
                   p{
                       transform: translateY(15%);
                   }
                   span{
                       display: block;
                   }
                   .ttNum{
                        font-size: 24px;
                        font-family: DINAlternate-Bold, DINAlternate;
                        font-weight: bold;
                        color: #555555;
                        line-height: 28px;
                   }
                   .ttTxt{
                       font-weight: 400;
                        color: #999999;
                        font-size: 13px;
                   }
               }
           }
       }
       .smallTit{
           margin-bottom: 8px;
           font-weight: 400;
           color: #666666;
       }
   }
   .pagination{
       padding-top: 32px !important;
       padding-bottom: 16px !important;
   }
}
.cleaningTable{
    .stateCss{
        padding: 3px 15px;
        box-sizing: border-box;
        font-size: 12px;
        font-weight: 400;
        border-radius: 2px;
        &.checkingCss{
            background: rgba(80, 136, 255, 0.15);
            color: #5088FF;
        }
        &.checkingCompleteCss{
            background: rgba(48, 191, 120, 0.15);
            color: #30BF78;
        }
   }
}
::v-deep{
    .cleaningTable{
        th.el-table__cell .cell{
            font-weight: bold;
        }
        th.el-table__cell{
            &:nth-of-type(1){
                .cell{
                    padding-left: 30px;
                    box-sizing: border-box;
                }
            }
        }
        tr{
                td.el-table__cell{
                    &:nth-of-type(1){
                        .cell{
                            padding-left: 30px;
                            box-sizing: border-box;
                        }
                    }
                }
        }
        
    }
    .total-sort{
        .item{
            .el-progress-circle {
                transform: rotateY(180deg);
            }
            .el-progress__text{
                        font-size: 14px !important;
                    }
            .pgs0{
                    .el-progress__text{
                        color: #30BF78;
                    }
            }
            .pgs1{
                    .el-progress__text{
                        color: #5088FF;
                    }
            }
            .pgs2{
                    .el-progress__text{
                        color: #BBBECA;
                    }
            }
            .pgs3{
                    .el-progress__text{
                        color: #FF0000;
                    }
            }
                
        }
    }
    .stImType{
            .tficon-shanchubiaoqianmoren{
                color: #ffffff;
                background: #abb1be;
                border-radius: 50%;
                font-size: 0px;
                vertical-align: top;
                margin-left: 2px;
                opacity: 0;
            }
            span{
                &:hover{
                    .tficon-shanchubiaoqianmoren{
                    opacity: 1;
                    font-size: 12px;
                  }
                } 
            }
    }
}
@media screen and (max-width:1488px){
    .cleaningTable{
         .stateCss{
            padding: 3px 6px;
        }
    }
    
}
@media screen and (max-width:1439px){
    .intelBox{
        .number-infor {
            .numItem{
                .total-sort{
                    padding: 0 0 0 15px;
                    .item{
                        min-width: 174px;
                    }
                }
           }
        }
    }
}
@media screen and (max-width:1290px){
   .cleaningTable{
           th.el-table__cell{
            &:nth-of-type(1){
                .cell{
                    padding-left: 0px;
                }
            }
        }
        
    }
      
}
</style>